module.exports = __webpack_public_path__ + "img/quick_style_1.f14f6c3c.svg";